// import { extendTheme } from "@chakra-ui/react";


// const activeLabelStyles = {
//   transform: "scale(0.85) translateY(-24px)"
// };

// export const customTheme = extendTheme({
//   // fontSizes: {
//   //   xs: "0.75rem", // 12 px
//   //   sm: "0.75rem", // 12 px
//   //   md: "0.875rem", // 14 px
//   // },
//   components: {
//     Checkbox: {
//       baseStyle: {
//         control: {
//           _checked: {
//             bg: "teal.300",
//             borderColor: "teal.300",
//           },
//           _focus: {
//             borderColor: "teal.500",
//             boxShadow: "none",
//           },
//           _hover: {
//             bg: "teal.300",
//             borderColor: "teal.300",
//           },
//           borderColor: "teal.200", 
//         },
//       },
//     },
//     Form: {
//       variants: {
//         floating: {
//           container: {
//             _focusWithin: {
//               label: {
//                 ...activeLabelStyles
//               }
//             },
//             "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label": {
//               ...activeLabelStyles
//             },
//             label: {
//               top: 0,
//               left: 0,
//               zIndex: 2,
//               position: "absolute",
//               backgroundColor: "white",
//               pointerEvents: "none",
//               mx: 3,
//               px: 1,
//               my: 2,
//               transformOrigin: "left top"
//             },

//           }
//         }
//       }
//     }
//   },


//   colors: {
//     teal: {
//       50: "#E6FFFA",
//       100: "#B2F5EA",
//       200: "#81E6D9",
//       300: "#4FD1C5",
//       400: "#38B2AC",
//       500: "#319795",
//       600: "#2C7A7B",
//       700: "#285E61",
//       800: "#234E52",
//       900: "#1D4044",
//     },
//     gray: {
//       50: "#F5F5F5",
//       100: "#EDF2F7",
//       200: "#E2E8F0",
//       300: "#CBD5E0",
//       400: "#A0AEC0",
//       500: "#718096",
//       600: "#4A5568",
//       700: "#2D3748",
//       800: "#1A202C",
//       900: "#171923",
//       1000: "#F8F9FA",
//       1100: "#E0E1E2",
//     },
//     blue: {
//       50: "#EBF8FF",
//       100: "#BEE3F8",
//       200: "#90CDF4",
//       300: "#63B3ED",
//       400: "#4299E1",
//       500: "#3182CE",
//       600: "#2B6CB0",
//       700: "#2C5282",
//       800: "#2A4365",
//       900: "#1A365D",
//     },
//     bluess: {
//       50: "#F2EDFF",
//       100: "#D9D4FF",
//       200: "#BFBAFA",
//       300: "#A5A0E0",
//       400: "#8C87C7",
//       500: "#736EAE",
//       600: "#595494",
//       700: "#403B7B",
//       800: "#262161",
//     },
//     green: {
//       50: "#F0FFF4",
//       100: "#C6F6D5",
//       200: "#9AE6B4",
//       300: "#68D391",
//       400: "#48BB78",
//       500: "#38A169",
//       600: "#2F855A",
//       700: "#276749",
//       800: "#22543D",
//       900: "#1C4532",
//     },
//     BlackAlpha: {
//       50: "rgba(0, 0, 0, 0.02)",
//       100: "rgba(0, 0, 0, 0.06)",
//       200: "rgba(0, 0, 0, 0.08)",
//       300: "rgba(0, 0, 0, 0.016)",
//     },
//   },
// });

import { extendTheme } from "@chakra-ui/react";

const activeLabelStyles = {
  transform: "scale(0.85) translateY(-24px)",
};

const approvalTableVariant = {
  table: {
    bg: "white",
  },
  th: {
    fontSize: "14px",
    fontWeight: "600",
    px: "0.45rem",
    py: "0.45rem",
    bg: "#1e3a5f",
    color: "#ffffff",
    borderColor: "#1e3a5f",
  },
  td: {
    fontSize: "14px",
    fontWeight: "400",
    px: "0.45rem",
    py: "0.45rem",
    color: "#3f4354",
    bg: "white",
    borderColor: "#e2e8f0",
  },
  tbody: {
    tr: {
      "&:nth-of-type(odd) td": {
        bg: "white",
      },
      "&:nth-of-type(even) td": {
        bg: "white",
      },
      "&:hover td": {
        bg: "#eff6ff",
      },
    },
  },
};

export const customTheme = extendTheme({
  fonts: {
    heading: 'Inter, "Roboto", "Helvetica Neue", Arial, sans-serif',
    body: 'Inter, "Roboto", "Helvetica Neue", Arial, sans-serif',
  },
  styles: {
    global: {
      body: {
        fontFamily: 'Inter, "Roboto", "Helvetica Neue", Arial, sans-serif',
        fontSize: "14px",
        color: "#3f4354",
      },
    },
  },
  colors: {
    teal: {
      // 50: "#E6FFFA",
      // 100: "#B2F5EA",
      // 200: "#81E6D9",
      // 300: "#4FD1C5",
      // 400: "#38B2AC",
      // 500: "#319795",
      // 600: "#2C7A7B",
      // 700: "#285E61",
      // 800: "#234E52",
      // 900: "#1D4044",

      50: "#e8ecfe",
      100: "#b9c7fd",
      200: "#a0b5fb",
      300: "#3b82f6", // accent: '#3b82f6',
      400: "#1d4ed8", // accent: '#1d4ed8', Hover
      500: "#376ecf",
      600: "#325ba9",
      700: "#2c4985",
      800: "#253762",
      900: "#1c2742",
    },
    primary: {
      300: "#0f172a", // Slate 900
    },
    secondary: {
      300: "#1e293b", // "#334155", // Slate 700
      400: "#93a2b7",
    },

    success: { 300: "#10b981" }, // green
    warning: { 300: "#f59e0b" }, // yellow
    danger: { 300: "#ef4444" }, // red

    gray: {
      50: "#F5F5F5",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
      1000: "#f1f5f9",
      // 1000: "#F8F9FA",
      1100: "#E0E1E2",
    },

    blue: {
      50: "#EBF8FF",
      100: "#BEE3F8",
      200: "#90CDF4",
      300: "#63B3ED",
      400: "#4299E1",
      500: "#3182CE",
      600: "#2B6CB0",
      700: "#2C5282",
      800: "#2A4365",
      900: "#1A365D",
    },
    bluess: {
      50: "#F2EDFF",
      100: "#D9D4FF",
      200: "#BFBAFA",
      300: "#A5A0E0",
      400: "#8C87C7",
      500: "#736EAE",
      600: "#595494",
      700: "#403B7B",
      800: "#262161",
    },

    BlackAlpha: {
      50: "rgba(0, 0, 0, 0.02)",
      100: "rgba(0, 0, 0, 0.06)",
      200: "rgba(0, 0, 0, 0.08)",
      300: "rgba(0, 0, 0, 0.016)",
    },
  },

  components: {
    Table: {
      baseStyle: {
        table: {
          bg: "white",
        },
        th: {
          fontFamily: 'Inter, "Roboto", "Helvetica Neue", Arial, sans-serif',
          fontSize: "14px",
          fontWeight: "600",
          px: "0.45rem",
          py: "0.45rem",
          textTransform: "none",
          letterSpacing: "normal",
        },
        td: {
          fontFamily: 'Inter, "Roboto", "Helvetica Neue", Arial, sans-serif',
          fontSize: "14px",
          fontWeight: "400",
          px: "0.45rem",
          py: "0.45rem",
          color: "#3f4354",
        },
      },
      variants: {
        simple: approvalTableVariant,
        striped: approvalTableVariant,
      },
      defaultProps: {
        variant: "simple",
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: "teal.300",
      },
      variants: {
        outline: {
          field: {
            borderColor: "gray.300",
            _hover: { borderColor: "teal.300" },
            _focus: { borderColor: "teal.300", boxShadow: "0 0 0 1px #3b82f6" },
          },
        },
      },
    },
    Select: {
      defaultProps: {
        focusBorderColor: "teal.300",
      },
      variants: {
        outline: {
          field: {
            borderColor: "gray.300",
            _hover: { borderColor: "teal.300" },
            _focus: { borderColor: "teal.300", boxShadow: "0 0 0 1px #3b82f6" },
          },
        },
      },
    },
    Textarea: {
      defaultProps: {
        focusBorderColor: "teal.300",
      },
      variants: {
        outline: {
          borderColor: "gray.300",
          _hover: { borderColor: "teal.300" },
          _focus: { borderColor: "teal.300", boxShadow: "0 0 0 1px #3b82f6" },
        },
      },
    },
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
              },
            },
            "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label":
            {
              ...activeLabelStyles,
            },
            label: {
              top: 0,
              left: 0,
              zIndex: 2,
              position: "absolute",
              backgroundColor: "white",
              pointerEvents: "none",
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: "left top",
            },
          },
        },
      },
    },
  },
});
